import { useTranslateCost } from "./translate-cost";
import { useTranslateNumber } from "./translate-number";

export const useTranslate = () => {
  const { translateNumber } = useTranslateNumber();
  const { translateCost, getCostSymbol } = useTranslateCost();

  return {
    translateNumber,
    translateCost,
    getCostSymbol,
  };
};
